"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.StyledLabel = exports.Container = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledIs = _interopRequireWildcard(require("styled-is"));
var _HBLabel = _interopRequireDefault(require("../HBLabel/HBLabel"));
var _HBText = require("../HBText/HBText.styles");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function getPlacementSyles(placement, spacing) {
  var marginBottom = spacing.marginBottom,
    marginLeft = spacing.marginLeft,
    marginRight = spacing.marginRight;
  switch (placement) {
    case 'right':
      return "\n\t\t\t\torder: 1;\n                margin-left: ".concat(marginLeft, ";\n\t\t\t");
    case 'left':
      return "\n                order: 0;\n                margin-right: ".concat(marginRight, ";\n        ");

    /* top */
    default:
      return "\n\t\t\t\tmargin-bottom: ".concat(marginBottom, ";\n\t\t\t");
  }
}

/* Label */
var LABEL_STYLES = {
  xxs: _HBText.newTextStyles.body12,
  xs: _HBText.newTextStyles.body12,
  sm: _HBText.newTextStyles.body14,
  md: _HBText.newTextStyles.body14,
  lg: _HBText.newTextStyles.body16,
  xl: _HBText.newTextStyles.body16
};
var StyledLabel = exports.StyledLabel = (0, _styledComponents["default"])(_HBLabel["default"]).withConfig({
  displayName: "HBFieldstyles__StyledLabel",
  componentId: "sc-clolyo-0"
})(["", ";", " ", " ", ";", ";", ";", ""], (0, _styledIs.isNot)('disabled')(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n\t\tcursor: ", ";\n    "])), function (props) {
  return props.id ? 'pointer' : 'default';
}), (0, _styledIs["default"])('withIcon')(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n        display: inline-flex;\n    "]))), (0, _styledIs["default"])('disabled')(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n        cursor: default;       \n    "]))), (0, _styledIs["default"])('inline')(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n\t\tdisplay: inline-block;\n\t\tvertical-align: top;\n\t\tmargin-right:  ", ";\n\t\tmargin-top:  ", ";\n\t"])), function (props) {
  return props.spacing.marginRight;
}, function (props) {
  return props.spacing.marginTop;
}), (0, _styledIs.isNot)('inline')(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n\t\t", ";\n\t"])), function (props) {
  return getPlacementSyles(props.placement, props.spacing);
}), (0, _styledIs["default"])('width')(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n\t\twidth: ", ";\n\t"])), function (props) {
  return props.width;
}), function (props) {
  return LABEL_STYLES[props.size];
});

/* Container */
var Container = exports.Container = _styledComponents["default"].div.withConfig({
  displayName: "HBFieldstyles__Container",
  componentId: "sc-clolyo-1"
})(["display:flex;", " ", ""], (0, _styledIs["default"])('inline')(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\twidth: 100%;\n    "]))), (0, _styledIs.isNot)('inline')(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2["default"])(["\n        ", "\n        ", "\n    "])), function (props) {
  return props.placement === 'top' && 'flex-direction: column;';
}, function (props) {
  return props.placement !== 'top' && 'align-items: center;';
}));
var Wrapper = exports.Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "HBFieldstyles__Wrapper",
  componentId: "sc-clolyo-2"
})(["display:flex;"]);
//# sourceMappingURL=HBField.styles.js.map